module.exports = __webpack_public_path__ + "static/media/webshop_splash_vehicles.ddbda6ea.jpg";